import React, { useState } from "react";
import { Box, Button, Typography, Dialog, DialogContent } from "@mui/material";

export default function PlanSelectionModal({
  openPlansModal,
  handleCancel,
  selectedPackage,
  selectedPlan,
  setSelectedPlan,
  handleConfirm,
  activePack,
}) {
  const [checkedPlan, setCheckedPlan] = useState(selectedPlan);
  console.log(activePack, selectedPackage, "activePack");
  const handleChoose = () => {
    setSelectedPlan(checkedPlan);
    handleConfirm(checkedPlan);
  };

  const planOptions = [
    {
      label: `$${selectedPackage?.prices[0]?.unit_amount / 100}/month`,
      value: "monthly",
    },
    {
      label: `$${selectedPackage?.prices[1]?.unit_amount / 100}/year`,
      value: "yearly",
    },
  ];

  return (
    <Box>
      <Dialog
        open={openPlansModal}
        onClose={handleCancel}
        PaperProps={{
          sx: {
            borderRadius: "34px",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "24px 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Title */}
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="700"
            sx={{
              fontSize: "28px",
              marginBottom: "12px",
            }}
          >
            {selectedPackage?.name}
          </Typography>

          {/* Plan Options */}
          {planOptions.map((option) => (
            <Box
              key={option.value}
              onClick={() => setCheckedPlan(option.value)}
              sx={{
                borderColor:
                  checkedPlan === option.value ? "#2A4876" : "#00000040",
                borderWidth: 1,
                borderStyle: "solid",
                width: "100%",
                height: "50px",
                borderRadius: "15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                padding: "5px 10px",
                cursor: "pointer",
              }}
            >
              <Typography
                sx={{
                  color: "#2A4876",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {option.label}
              </Typography>
              <input
                type="radio"
                name="plan"
                value={option.value}
                checked={checkedPlan === option.value}
                readOnly
                style={{
                  accentColor: "#2A4876",
                  pointerEvents: "none",
                }}
              />
            </Box>
          ))}

          {/* Buttons */}
          <Box display="flex" justifyContent="center" gap={0.5}>
            <Button
              onClick={() => {
                handleCancel();
                setSelectedPlan("");
              }}
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "transparent",
                color: "#152134",
                fontWeight: "400",
                fontSize: "18px",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#C4CED8" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleChoose}
              disabled={!checkedPlan}
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF !important",
                fontWeight: "400",
                padding: "12px 44px",
                fontSize: "18px",
                "&:hover": { backgroundColor: "#002A5C" },
                "&.Mui-disabled": {
                  background: "#AAB6C8",
                },
              }}
            >
              Choose
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
